import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Button } from "@mui/material";
import { changeSlotMonth } from "../../../slices/slotManagement";
import { useDispatch } from "react-redux";
import { DeleteIcon } from "../../../../assets/common-svg/CommonSvg";

const getEventColor = (type, eventProps = {}) => {
    const {
        // change_requests: changeRequests = [], //@info commented due to build failed
        // cr_status: crStatus,
        // change_request: changeRequest,
        // has_open_change_request: hasOpenChangeRequest,
        // is_open_request: isOpenRequest,
        // is_cr: isCr,
        is_cr_raised: isCrRaised,
        // cr_status_file: crStatusFile,
        // cr_status_comment: crStatusComment,
        // slot_alignment_reason: slotAlignmentReason,
    } = eventProps || {};

    // const pendingCrStatusStrings = new Set([ //@info commented due to build failed
    //     "pending",
    //     "open",
    //     "raised",
    //     "submitted",
    //     "in_progress",
    //     "in progress",
    //     "awaiting",
    //     "awaiting_approval",
    // ]);

    // const isTruthyCRFlag = (value) => { //@info commented due to build failed
    //     if (
    //         value === true ||
    //         value === 1 ||
    //         value === "1" ||
    //         value === "true"
    //     ) {
    //         return true;
    //     }
    //     if (typeof value === "string" && value.trim() !== "") {
    //         return pendingCrStatusStrings.has(value.trim().toLowerCase());
    //     }
    //     return false;
    // };

    // const reasonText = String(slotAlignmentReason || "").toLowerCase(); //@info commented due to build failed
    // const hasCrReasonText =
    //     reasonText.includes("cr raise") ||
    //     reasonText.includes("cr raised") ||
    //     reasonText.includes("change request") ||
    //     reasonText.includes("change-request");


    const hasRaisedOrPendingCR = isCrRaised == 1

    // const hasRaisedOrPendingCR =
    //     (Array.isArray(changeRequests) && changeRequests.length > 0) ||
    //     isTruthyCRFlag(crStatus) ||
    //     isTruthyCRFlag(changeRequest) ||
    //     isTruthyCRFlag(hasOpenChangeRequest) ||
    //     isTruthyCRFlag(isOpenRequest) ||
    //     isTruthyCRFlag(isCr) ||
    //     isTruthyCRFlag(isCrRaised) ||
    //     isTruthyCRFlag(crStatusFile) ||
    //     isTruthyCRFlag(crStatusComment) ||
    //     hasCrReasonText;

    if (hasRaisedOrPendingCR) {
        return "#9C27B0"; // Purple when CR is raised/pending
    }

    switch (type) {
        case "Request":
            return "#FB9D2C";
        case "Available":
            return "#00B278";
        case "Booked":
            return "#F44141";
        default:
            return "#1E90FF";
    }
};

const Calendar = ({
    handleAdd,
    allEvents = [],
    handleDelete,
    deleteIcon,
    visibleRange,
    location = "",
    selectedSlot = "",
    handleSelectedSlot,
    allPreferredDate = []
}) => {

    const dispatch = useDispatch();
    const calendarRef = useRef(null);
    const calendarContainerRef = useRef(null);
    const [highlightRange, setHighlightRange] = useState([]);
    const [externalDeleteInfo, setExternalDeleteInfo] = useState(null);
    const [isEventHovered, setIsEventHovered] = useState(false);
    const [isButtonHovered, setIsButtonHovered] = useState(false);
    useEffect(() => {
        if (visibleRange) {
            setHighlightRange([
                {
                    id: "highlight",
                    start: visibleRange.start,
                    end: visibleRange.end,
                    display: "background",
                    backgroundColor: "#E8EFFC",
                    border: "1px solid rgb(25, 88, 235)",
                    borderRadius: "1px",
                },
            ]);
        }
    }, [visibleRange]);

    const setInitialDates = () => {
        const calendarApi = calendarRef.current?.getApi();
        if (calendarApi && visibleRange) {
            calendarApi.select(visibleRange?.start, visibleRange?.end);
        }
    };

    useEffect(() => {
        if (visibleRange) {
            setInitialDates();
        }
    }, []);

    const handleDatesSet = async () => {
        const calendarApi = calendarRef.current?.getApi();
        const currentStart = calendarApi?.getDate();
        if (currentStart) {
            const year = currentStart.getFullYear();
            const month = currentStart.getMonth();
            const currentDate = new Date(year, month, 1);
            await dispatch(changeSlotMonth(currentDate));
            if (visibleRange) {
                setInitialDates();
            }
        }
    };

    useEffect(() => {
        if (calendarRef.current) {
            handleDatesSet();
        }
    }, []);

    // Manage hiding when both hovers are false
    useEffect(() => {
        if (!isEventHovered && !isButtonHovered) {
            const timeout = setTimeout(() => {
                setExternalDeleteInfo(null);
            }, 150);
            return () => clearTimeout(timeout);
        }
    }, [isEventHovered, isButtonHovered]);

    const isInVisibleRange = (date) => {
        if (!visibleRange) return true;
        const start = new Date(visibleRange.start);
        // const end = new Date(visibleRange.end);
        return date >= start
        // return date >= start && date < end;
    };

    const closeMorePopover = () => {
        const calendarContainer = calendarContainerRef?.current;
        if (!calendarContainer) return;

        const closeButton = calendarContainer.querySelector(".fc-popover .fc-popover-close");
        if (closeButton) {
            closeButton.click();
            return;
        }

        const popovers = calendarContainer.querySelectorAll(".fc-popover");
        popovers.forEach((popover) => popover.remove());
    };

    const handleEventClick = (clickInfo) => {
        const eventStartDate = clickInfo?.event?.start;
        if ((isInVisibleRange(eventStartDate) && handleSelectedSlot)) {
            closeMorePopover();
            handleSelectedSlot(clickInfo?.event?.id, eventStartDate, clickInfo?.event);
        }
    };

    const renderEventContent = (eventInfo) => {
        if (eventInfo?.event.display === "background") return null;
        return (
            <div className="relative group w-100">
                <div
                    className={selectedSlot == eventInfo?.event?.id ? ` border-2 border-[blue]` : ` `}
                    style={{
                        marginLeft: "7px",
                        width: "93%",
                        backgroundColor: getEventColor(
                            eventInfo?.event.extendedProps.type,
                            eventInfo?.event.extendedProps
                        ),
                        padding: "5px",
                        borderRadius: "4px",
                        color: "#fff",
                        textAlign: "center",
                        position: "relative",
                    }}
                >
                    <strong className="text-wrap">
                        {eventInfo?.event?.title?.includes('-') ? eventInfo?.event?.title?.slice(0, -2) : eventInfo?.event?.title} {eventInfo?.event?.extendedProps?.type == 'Request' ? 'Booked' : eventInfo?.event?.extendedProps?.type == 'Booked' ? 'Confirmed' : eventInfo?.event?.extendedProps?.type}
                        {eventInfo?.event?._def?.extendedProps?.patient_name && ` For ${eventInfo?.event?._def?.extendedProps?.patient_name}`}
                    </strong>
                </div>
            </div >
        );
    };

    const dayCellContent = (info) => {
        return (
            <div className="text-center">
                <div style={{ textAlign: "center", fontWeight: "bold" }}>{info.dayNumberText}</div>
                {handleAdd && (
                    <Button
                        onClick={() => handleAdd(info)}
                        size="small"
                        disabled={!location}
                        sx={{ width: "90% !important" }}
                        className="bg-[#DDDDDD] text-[#828282]"
                    >
                        + Add Slot
                    </Button>
                )}
            </div>
        );
    };
    // Add validRange configuration
    const validRange = visibleRange ? {
        start: visibleRange.start
    } : null;

    // Add selectAllow callback to prevent selection of disabled dates
    const selectAllow = (selectInfo) => {
        if (!visibleRange) return true;
        return selectInfo.start >= new Date(visibleRange.start);
    };

    const preferredDates = allPreferredDate?.map(d => {
        const [day, month, year] = d.split("/");
        return new Date(year, month - 1, day);
    });

    const handleDisableClass = (arg) => {
        // FullCalendar gives local Date already
        const cellDate = new Date(arg?.date?.getFullYear(), arg?.date?.getMonth(), arg?.date?.getDate());
        // Construct startDate also in local time (NOT from string)
        const vs = new Date(visibleRange?.start);
        const startDate = new Date(vs?.getFullYear(), vs?.getMonth(), vs?.getDate());
        const isBeforeStart = cellDate < startDate;
        if (visibleRange && isBeforeStart) {
            return 'disabled-date';
        }
        // ⭐ NEW: Highlight preferred dates
        const isPreferred = preferredDates?.some(
            (p) => p.toDateString() === cellDate.toDateString()
        );

        if (isPreferred) {
            return "preferred-date-highlight"; // CSS class
        }
        return '';
    }

    const handleEventDidMount = ({ info, handleAdd, setExternalDeleteInfo, setIsEventHovered, calendarContainerRef }) => {
        const slotStatus = info?.event?._def?.extendedProps?.type
        const isActiveDelete = slotStatus == "Request" || slotStatus == "Booked"
        const eventType = info?.event?._def?.extendedProps?.eventType
        if (info.event?.id === "highlight") return;
        if (eventType === "preferred_date") {
            // Find the parent day cell and add purple border to it
            const dayCell = info.el.closest('.fc-day');
            if (dayCell) {
                dayCell.style.border = "2px solid #fbfb2cfe";
                dayCell.style.borderRadius = "8px";
                dayCell.style.backgroundColor = "#fbf72cc8";
                dayCell.style.boxShadow = "0 0 0 2px #fbfb2cfe";
            }
        }

        if (handleAdd && !isActiveDelete) {
            const el = info?.el;
            el.addEventListener("mouseenter", () => {
                const rect = el?.getBoundingClientRect();
                const containerRect = calendarContainerRef?.current?.getBoundingClientRect();

                setExternalDeleteInfo({
                    id: info?.event?.id,
                    start: info?.event?.start,
                    top: rect?.top - containerRect?.top + 20,
                    left: rect?.left - containerRect?.left + 60,
                });
                setIsEventHovered(true);
            });

            el.addEventListener("mouseleave", () => {
                setIsEventHovered(false);
            });
        }
    }

    return (
        <div className="relative" ref={calendarContainerRef}>
            <div className="p-[0.8rem] relative bg-white">
                <div className="text-sm text-[14px] font-bold absolute mt-2">{location}</div>
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    initialDate={new Date()}
                    headerToolbar={{
                        left: "",
                        right: "title prev,next dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    events={[...highlightRange, ...allEvents]}
                    eventDidMount={(info) =>
                        handleEventDidMount({
                            info,
                            handleAdd,
                            setExternalDeleteInfo,
                            setIsEventHovered,
                            calendarContainerRef
                        })
                    }
                    // ... existing props ...
                    validRange={validRange}
                    selectAllow={selectAllow}
                    dayCellClassNames={(arg) => handleDisableClass(arg)}
                    dateClick={() => { }}
                    editable
                    showNonCurrentDates={true}
                    selectable={false}
                    // height="auto"
                    eventContent={renderEventContent}
                    eventClick={handleEventClick}
                    dayCellContent={dayCellContent}
                    dayMaxEventRows={true}
                    views={{
                        timeGrid: {
                            dayMaxEventRows: 2,
                        },
                    }}
                    datesSet={handleDatesSet}
                />
            </div>

            {/* External Delete Button */}
            {externalDeleteInfo && deleteIcon && (
                <div
                    className="absolute z-[9999]"
                    style={{
                        top: externalDeleteInfo.top,
                        left: externalDeleteInfo.left,
                    }}
                    onMouseEnter={() => setIsButtonHovered(true)}
                    onMouseLeave={() => setIsButtonHovered(false)}
                >
                    <Button
                        startIcon={<DeleteIcon />}
                        className="bg-[#FFFFFF] text-[#828282] text-xs rounded shadow"
                        onClick={() => {
                            handleDelete(externalDeleteInfo.id, externalDeleteInfo.start);
                            setExternalDeleteInfo(null);
                        }}
                    >
                        Delete
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Calendar;